var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandshake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-handshake h-8 w-8 text-primary",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11 17 2 2a1 1 0 1 0 3-3",
    stroke: "#18181B",
    fill: "none",
    strokeWidth: "2px"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14 14 2.5 2.5a1 1 0 1 0 3-3l-3.88-3.88a3 3 0 0 0-4.24 0l-.88.88a1 1 0 1 1-3-3l2.81-2.81a5.79 5.79 0 0 1 7.06-.87l.47.28a2 2 0 0 0 1.42.25L21 4",
    stroke: "#18181B",
    fill: "none",
    strokeWidth: "2px"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21 3 1 11h-2",
    stroke: "#18181B",
    fill: "none",
    strokeWidth: "2px"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3 2 14l6.5 6.5a1 1 0 1 0 3-3",
    stroke: "#18181B",
    fill: "none",
    strokeWidth: "2px"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4h8",
    stroke: "#18181B",
    fill: "none",
    strokeWidth: "2px"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshake);
export default __webpack_public_path__ + "static/media/handshake.6d101f82a2832dd898d18f2aa8943f61.svg";
export { ForwardRef as ReactComponent };